export enum UserStatus {
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
  DISABLED = "DISABLED",
}

export enum UserRole {
  SUPER_ADMIN = "SUPER_ADMIN",
  ORG_ADMIN = "ORG_ADMIN",
  COORDINATOR = "COORDINATOR",
  VOLUNTEER = "VOLUNTEER",
}

interface UserProfile {
  id: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  termsOfUseAccepted?: boolean;
  status: UserStatus;
  organizations?: Array<{ id: string; name: string; role: string }>;
}

export interface UserProfileAdminResponse extends UserProfile {
  role: UserRole;
  avatar?: string | null;
}

export interface UserProfileAuthResponse extends UserProfile {
  isSuperAdmin: boolean;
}

export interface UserSignInResponse {
  token: string;
  expiresIn: string;
  user: {
    id: string;
    email: string;
    role: UserRole;
    organizationId?: string;
  };
}

export interface User {
  id: string;
  name: string;
  email: string;
  organization: string;
  role: string;
  avatar?: string | null;
  status: UserStatus;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  dateOfBirth?: string | null;
  addressOfLiving?: string | null;
  cognitoSub?: string;
  createdAt: string;
  updatedAt: string;
  organizations?: Array<{
    id: string;
    name: string;
    role: string;
    userOrganizationId?: string;
  }>;
}

export interface UserDocument {
  id: string;
  userId: string;
  name: string;
  fileName: string;
  filePath: string;
  fileExtension: string;
  fileSize: number;
  fileSizeFormatted: string;
  mimeType: string;
  type:
    | "RESUME"
    | "CERTIFICATE"
    | "ID_DOCUMENT"
    | "CONTRACT"
    | "INSURANCE"
    | "TRAINING_RECORD"
    | "BACKGROUND_CHECK"
    | "WORK_PERMIT"
    | "OTHER";
  description: string | null;
  uploadedBy: string;
  uploadedAt: string;
  createdAt: string;
  updatedAt: string;
  downloadUrl?: string;
  uploadedByUser?: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
  };
}
